import { render, staticRenderFns } from "./BStep3.vue?vue&type=template&id=732c5b45&scoped=true"
import script from "./BStep3.vue?vue&type=script&lang=js"
export * from "./BStep3.vue?vue&type=script&lang=js"
import style0 from "./BStep3.vue?vue&type=style&index=0&id=732c5b45&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "732c5b45",
  null
  
)

export default component.exports